/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_Speaker_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This browser cannot choose the speaker." |
*
* @param {Practice_Session_Audio_Speaker_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_speaker_unsupported = /** @type {((inputs?: Practice_Session_Audio_Speaker_UnsupportedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_Speaker_UnsupportedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("In deze browser kan je de luidspreker niet kiezen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce navigateur ne permet pas de choisir le haut-parleur.")
	return /** @type {LocalizedString} */ ("This browser cannot choose the speaker.")
});